<style scoped>
  .btn-text:active {
    color: #2b85e4 !important;
  }
</style>

<template>
  <app-layout style="margin: 16px">
    <p style="text-align:center;font-size: 3vh;line-height: 1.5;margin-bottom:16px">
      You are welcome to observe the Sharpen Founder experience as a guest.
    </p>
    <div display="flex" style="padding:10px">
      <router-link to="/home">
        <Button type="primary" style="float:right">Continue as Guest</Button>
      </router-link>
      <span @click="goBack()" class="btn-text" style="float:right;padding:6px 15px;color:#495060">
        Go Back
      </span>
    </div>
  </app-layout>
</template>

<script>
  export default {
    name: "StepTwoMobileComponent",
    data() {
      return {};
    },
    methods: {
      goBack() {
        window.history.back();
      },
    }
  };
</script>